import { memo, ReactNode } from 'react'
import IconSliderArrowDown from 'assets/slider-arrow-down.svg?react'
import cn from 'classnames'
import { ButtonIcon } from 'components/extend/ButtonIcon'

import defaultTheme from './LayoutMobile.module.less'

interface IProps {
  children: ReactNode
  /** Слот в шапке справа */
  action?: ReactNode
  className?: string
  classNameContentWrapper?: string
  /* Слот для кнопки действия */
  footer?: ReactNode
  footerClassName?: string
  /* Слот в шапке снизу */
  header?: ReactNode
  isShowCloseButton?: boolean
  onClose?: () => void
  onSubmit?: () => void
  theme?: typeof defaultTheme
  title?: ReactNode
}

export const LayoutMobile = memo(function LayoutMobile({
  children,
  className,
  title,
  footerClassName,
  footer,
  header,
  isShowCloseButton = true,
  action,
  onClose,
  theme
}: IProps) {
  const s = theme || defaultTheme

  return (
    <div className={cn(s.LayoutMobile, className)}>
      <div className={s.header}>
        <div className={s.header__main}>
          {isShowCloseButton && !!onClose && (
            <ButtonIcon className={s.closeIcon} color="gray" icon={IconSliderArrowDown} onClick={onClose} />
          )}
          <div className={s.title}>{title}</div>
          {!!action && <span>{action}</span>}
        </div>
        {!!header && <div>{header}</div>}
      </div>
      <div className={cn(s.contentWrapper, { [s.contentWrapper_withFooter]: footer })}>{children}</div>
      {!!footer && <div className={cn(s.footer, footerClassName)}>{footer}</div>}
    </div>
  )
})
